/**
 * Suggest item block
 */

define((require) => {
    'use strict';

    const toolkit = require('toolkit/b-toolkit/b-toolkit');

    return toolkit.create('suggest__item', {
        getValue() {
            return this._value;
        },

        onRender() {
            this._value = '';
        },
    });
});
